export default __webpack_public_path__ + "2498928700713022b8345620a60f95de.png";